import React from 'react';


export const StudioContext = React.createContext<any>({
  currentGame: {},
  currentMenu: {},
  // Segment 切换相关
  activeTab: 'operation',
  activeDashboardList: [],
  onTabChange: () => {},
  hasResearchList: false,
});
StudioContext.displayName = 'StudioContext';

